import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { query, where, getDocs, collection } from "firebase/firestore";
//import { db } from "../firebase";  
import Cookies from 'js-cookie';
//page links   
import './footer.css';
import GooglePlayIcon from '../assets/android-app_v1.png';
import Appstore from '../assets/ios-app_v1.png';
import { BsYoutube } from 'react-icons/bs';
import Save_inquary from './save_inquary';
export default function Footers() {
  const navigate = useNavigate();
  const location = useLocation();
  const [Jobtasks, setJobtasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [rowCounts, setRowCounts] = useState({
    users: 0,
    postdata: 0,
    companys: 0,
    total: 0
  });




  return (
    <div className="footer-body items-back-fill-dark">
 
      <div className="tearms_body">
        <div className="container_size"> 
              <table>
                <tr  > 
                  <td> <b className='bold'>Aooz</b> - {new Date().getFullYear()} All rights reserved. </td>
                 <td width={150} className='text-r'>  
                  <a className="tab-link text-h3" title='Terms and Conditions' href='/terms-and-conditions'>Terms and Conditions</a>
                   </td>
                  </tr> 
                </table> 
      
        </div>
      </div>
    </div>
  );
}
